import { render, staticRenderFns } from "./ApproveModelRiskV2.vue?vue&type=template&id=d53f39a8&scoped=true&"
import script from "./ApproveModelRiskV2.vue?vue&type=script&lang=js&"
export * from "./ApproveModelRiskV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53f39a8",
  null
  
)

export default component.exports